class ReferenceList extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-referencelist-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 0,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0,
                }
            },
            pagination: {
                el: '[data-referencelist-pagination]',
                clickable: true
            },
        });
    }
}
